module.exports = __webpack_public_path__ + "img/ncs-white.14b7fd73.png";